



























import { Vue, Component, Watch, Prop } from "@/shared/vuepack";
import { useAdminHsaStoreInfoStore } from "@/admin/store/hsaStoreInfo";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { HsaStoreVisibility, HsaStoreVisibilityRequest } from "@/shared/types";
import VueRouter from "vue-router";
import { Validator } from "vee-validate";

@Component({})
export default class HsaStoreConfigurationV2 extends Vue {
  adminHsaStoreInfoStore = useAdminHsaStoreInfoStore();
  featureFlagStore = useFeatureFlagStore();

  $router: VueRouter;
  $validator: Validator;

  isSubmitting = false;

  @Prop() partnerId: number;
  @Prop() employerId: number;
  @Prop({ default: "partner" }) userType: "partner" | "employer";

  get currentId () {
    return this.userType === "employer"
      ? this.employerId || parseInt(this.$route.params.employerId)
      : this.partnerId || parseInt(this.$route.params.partnerId);
  }

  get hsaStores (): HsaStoreVisibility[] {
    return this.userType === "employer"
      ? this.adminHsaStoreInfoStore.employerHsaStoreInfos
      : this.adminHsaStoreInfoStore.partnerHsaStoreInfos;
  }

  get submitDisabled () {
    return this.$validator.errors.any() || this.isSubmitting;
  }

  mounted () {
    const id = this.currentId;

    if (this.userType === "employer") {
      this.adminHsaStoreInfoStore.unloadEmployerHsaStoreInfos();
      this.adminHsaStoreInfoStore.getEmployerHsaStoreInfos(id);
    } else {
      this.adminHsaStoreInfoStore.unloadPartnerHsaStoreInfos();
      this.adminHsaStoreInfoStore.getPartnerHsaStoreInfos(id);
    }
  }

  submit () {
    this.$validator.validateAll().then(isValid => {
      if (!isValid) return;

      this.isSubmitting = true;

      const payload: HsaStoreVisibilityRequest[] = this.hsaStores.map(store => ({
        hsaStoreInfoId: store.hsaStoreInfoId,
        enabled: store.enabled
      }));

      const saveCall =
        this.userType === "employer"
          ? this.adminHsaStoreInfoStore.saveEmployerHsaStoreInfos?.(this.currentId, payload)
          : this.adminHsaStoreInfoStore.savePartnerHsaStoreInfos(this.currentId, payload);

      saveCall.finally(() => (this.isSubmitting = false));
    });
  }
}
